import $axios from "@/plugins/axios-instance";

export default {
  state: {},
  getters: {},
  mutations: {},

  actions: {
    fetchMessageGroups(context, { nameFilter, page }) {
      return $axios
        .get(`/alerts/messageGroups`, {
          params: {
            skip: (page - 1) * 10,
            take: 10,
            nameFilter
          }
        })
        .then(response => {
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },
    createAlert(context, form) {
      return $axios
        .post(`/alerts`, form)
        .then(response => {
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },

    fetchMessages(context, { messageGroupId, page }) {
      return $axios
        .get(`/alerts/messageGroups/${messageGroupId}/messages`, {
          params: {
            skip: (page - 1) * 20,
            take: 20
          }
        })
        .then(response => {
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },
    fetchModerateMessages(context, { status, skip, take }) {
      return $axios
        .get(`/alerts/moderatebleMessages`, {
          params: {
            status,
            skip,
            take
          }
        })
        .then(response => {
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },

    createMessage(context, { messageGroupId, content }) {
      return $axios
        .post(`/alerts/messageGroups/${messageGroupId}/messages`, { content })
        .then(response => {
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    }
  }
};
